import React from 'react'
import { Redirect } from 'react-router-dom'

const LoginRedirect = (props) => {
    let loginDetails = localStorage.getItem("loginDetails");
    if(loginDetails){
        return <Redirect to='/selectWorkOrder' />
    } else {
        return (
            <>
                {props.children}
            </>
        )
    }
}

export default LoginRedirect